import React from "react";

const Hero: React.FC = () => {
  return (
    <section className="hero" id="top">
      <p className="hero__title">
        Eat where Kozhikode eats.
      </p>
      <p className="hero__sub">
        A clean, locally curated map of restaurants, beach shacks, and street
        stalls in Calicut, that locals actually recommend.
      </p>
    </section>
  );
};

export default Hero;